<template>
	<div class="task-group-skeleton">
		<div class="task-group-skeleton__header flex items-center justify-between mb-4">
			<div class="task-group-skeleton__title w-25 skeleton" />
		</div>
		<div v-for="index of taskCount" :key="index" class="task-group-skeleton__task skeleton" />
	</div>
</template>

<script>
	import { defineComponent } from 'vue';

	export default defineComponent({
		name: 'TaskGroupSkeleton',
		setup() {
			return {
				taskCount: Math.floor(Math.random() * 3) + 1
			};
		}
	});
</script>

<style lang="scss">
.task-group-skeleton {
	container: task-group-skeleton / inline-size;

	& + & {
		margin-top: $space__6;
	}

	&__header {
		height: 50px;
	}

	&__title {
		height: 27px;
	}

	&__task {
		height: 79px;

		& + .task-group-skeleton__task {
			margin-top: $space__4;
		}
	}
}
</style>